module.exports = __webpack_public_path__ + "static/media/oberflex-cheneanoeuds-2560x1440.ead51009.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneanoeuds-2560x1440.jpg
// module id = 995
// module chunks = 37